<template>
	<header class="header py-6" :class="{ 'header--logged' : authenticated, 'header--dark' : dark,  'header--border' : dark, 'bg-white' : background === 'white' }">
		<portal v-if="impersonating" to="modal">
			<div class="c-snackbar d-flex justify-content-center">
				<span class="text-white font_14_19">Logged in as {{ profileName }}. Switch back to Regional user <a href="#" @click.prevent="stopImpersonate">here.</a></span>
				<a class="c-snackbar__close" href="#" @click.prevent="hideTheSnackbar"><icon-close color="white" /></a>
			</div>
		</portal>
		<!-- Desktop Menu -->
		<div class="container d-none d-lg-block">
			<div class="d-flex justify-content-between align-items-center">
				<div class="mt-n4">
					<a href="/"><img class="c-logo" :src="logo" alt="Regions With Nature logo" /></a>
				</div>
				<div class="d-flex align-items-center">
					<ul class="d-flex align-items-center mb-0">
						<!-- For regions -->
						<li class="c-menu-item mr-8">
							<a 
								class="font_16_21 d-flex align-items-center noOutsideClick" 
								href="#" @click.prevent="toggleSubmenu('forCities')" 
								@mouseover="forCitiesIconColor = dark ? '#71b96c' : '#71b96c'"  
								@mouseleave="forCitiesIconColor = dark ? '#231f20' : '#231f20'"
							>For regions <icon-drop-arrow :color="forCitiesIconColor" class="ml-1" /></a>
							<div v-show="$store.state.activeNavSubmenu == 'forCities'" class="c-submenu">
								<ul>
									<li v-if="authenticated" ><a class="font_16_21" href="/actions-dashboard/">Action platform</a></li>
									<li v-else ><a class="font_16_21" href="/actions/">Action platform</a></li>
									<!--<li class=""><a class="font_16_21" href="/guides/">Guides</a></li>-->
								</ul>
							</div>
						</li>

						<!-- For communities -->
						<li class="c-menu-item mr-8">
							<a 
								class="font_16_21 d-flex align-items-center noOutsideClick" 
								href="#" 
								@click.prevent="toggleSubmenu('forCommunities')" 
								@mouseover="forCommunitiesIconColor = dark ? '#248A86' : '#FABD39'"  
								@mouseleave="forCommunitiesIconColor = dark ? '#231F20' : '#FFFFFF'"
							>For communities <icon-drop-arrow :color="forCommunitiesIconColor" class="ml-1" /></a>
							<div v-show="$store.state.activeNavSubmenu == 'forCommunities'" class="c-submenu">
								<ul>
									<li class="mb-6"><a class="font_16_21" href="/tools-and-resources/">Tools &amp; resources</a></li>
									<li><a class="font_16_21" href="/region-profiles/">Region profiles</a></li>
 								</ul>
							</div>
						</li>

						<li class="c-menu-item mr-8">
							<a 
								class="font_16_21 d-flex align-items-center noOutsideClick" 
								href="#" 
								@click.prevent="toggleSubmenu('forInfo')" 
								@mouseover="infoIconColor = dark ? '#248A86' : '#FABD39'"  
								@mouseleave="infoIconColor = dark ? '#231F20' : '#FFFFFF'"
							>Info <icon-drop-arrow :color="infoIconColor" class="ml-1" /></a>
							<div v-show="$store.state.activeNavSubmenu == 'forInfo'" class="c-submenu">
								<ul>
									<li class="mb-6"><a class="font_16_21" href="/what-our-regions-are-doing/">What our regions are doing</a></li>
									<li class="mb-6"><a class="font_16_21" href="/the-case-study-database">Case study database</a></li>
									<li class="mb-6"><a class="font_16_21" href="/newsletters/">Buzz newsletters</a></li>
									<li class="mb-6"><a class="font_16_21" href="/updates">News</a></li>
									<li><a class="font_16_21" href="/contact">Contact</a></li>
								</ul>
							</div>
						</li>
					</ul>
					
					<ul class="d-flex align-items-center mb-0 mr-4">
						<li class="mr-4">
							<a 
								href="https://bsky.app/profile/citieswithnature.org" 
								target="_blank" 
								rel="nofollow noopener" 
								@mouseover="twitterIconColor = dark ? '#248A86' : '#FABD39'"  
								@mouseleave="twitterIconColor = dark ? '#4B4B4B' : '#FFFFFF'"
							>
								<icon-bluesky class="d-block" :color="twitterIconColor" />
							</a>
						</li>
						<li class="mr-4">
							<a href="https://www.linkedin.com/company/citieswithnature-regionswithnature" 
								target="_blank" 
								rel="nofollow noopener" 
								@mouseover="linkedinIconColor = dark ? '#248A86' : '#FABD39'"  
								@mouseleave="linkedinIconColor = dark ? '#4B4B4B' : '#FFFFFF'"
							>
								<icon-linkedin class="d-block" :color="linkedinIconColor" />
							</a>
						</li>
						<li>
							<a 
								href="mailto:info@regionswithnature.org" 
								@mouseover="mailIconColor = dark ? '#248A86' : '#FABD39'"  
								@mouseleave="mailIconColor = dark ? '#4B4B4B' : '#FFFFFF'"
							>
								<icon-mail class="d-block" :color="mailIconColor" />
							</a>
						</li>
					</ul>
				</div>
				<div class="d-flex justify-content-end align-items-center">
					<div class="c-search mr-5" :class="{  'c-search--open' : searchOpen }">
						<form @submit.prevent="submitSearch">
							<input class="c-search-input" v-if="searchOpen" type="search" v-model="searchTerm" placeholder="Search by keyword" />
							<a href="#" 
								@mouseover="searchIconColor = dark ? '#71b96c' : '#71b96c'"  
								@mouseleave="searchIconColor = dark ? '#231f20' : '#231f20'"
							>
								<icon-search class="d-block c-search-icon" :color="searchIconColor" @click.native="toggleSearch" />
							</a>
						</form>
					</div>
					<ps-auth />
				</div>
			</div>
		</div>

		<!-- Mobile Menu -->
		<div class="bottom-area-header d-lg-none">
			<div class="container d-flex align-items-center justify-content-between">
				<a class="hamburger" href="#" @click.prevent="toggleMobileNav">
					<icon-hamburger />
				</a>
				<div class="logo">
					<a href="/"><img class="c-logo" src="/wp-content/themes/cwn/dist/images/logo-color.png" alt="Cities With Nature logo showing a leaf."></a>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCookie } from '../helpers/Cookies'

export default {
	name: 'PsNavigation',
	data: () => ({
		searchOpen: false,
		searchTerm: '',
		forCitiesIconColor: '#231f20',
		forCommunitiesIconColor: '#231f20',
		infoIconColor: '#231f20',
		pathwaysIconColor: '#231f20',
		actionIconColor: '#231f20',
		twitterIconColor: '#231f20',
		mailIconColor: '#231f20',
		linkedinIconColor: '#231f20',
		searchIconColor: '#231f20',
		notificationsIconColor: '#231f20',
		burgerActive: false,
	}),
	props: {
		dark: {
			type: Boolean,
			default: false
		},
		background: {
			type: String,
			default: ''
		},
		border: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		toggleSubmenu(name) {
			if (this.$store.state.activeNavSubmenu != name) {
				this.$store.commit('setActiveNavSubmenu', name)
			}
			else {
				this.$store.commit('setActiveNavSubmenu', false)
			}
		},

		toggleMobileNav() {
			this.$store.commit('toggleMobileNav')
		},

		toggleSearch() {
			this.searchOpen = !this.searchOpen
		},

		submitSearch() {
			window.location.href = '/?s=' + this.searchTerm
		},

		
	},
	computed: {
		...mapGetters({
			authenticated: 'authenticated',
			me: 'getMe',
			impersonating: 'impersonating'
		}),

		myCityName() {
			return getCookie('user_org')
		},

		logo() {
			if (this.dark) {
				return '/wp-content/themes/cwn/dist/images/logo-color.png'
			}
			return '/wp-content/themes/cwn/dist/images/logo-white.png'
		},

		iconActiveColor() {
			return this.dark ? '#71B96C' : '#71B96C'
		},

		iconColor() {
			return this.dark ? '#4B4B4B' : '#4B4B4B'
		},

		profileName() {
			if (this.me.type == 'REGION_ADMIN' && this.me.regional_office) {
				return this.me.regional_office.name
			}

			if (this.me.cities) {
				return this.me.cities[0].name
			}

			return 'N/A'
		}
	},
	created() {
		this.searchIconColor = this.iconColor
		this.forCitiesIconColor = this.iconColor
		this.forCommunitiesIconColor = this.iconColor
		this.infoIconColor = this.iconColor

		this.twitterIconColor = this.iconColor
		this.mailIconColor = this.iconColor
		this.linkedinIconColor = this.iconColor
		this.notificationsIconColor = this.iconColor
	},
}
</script>

<style lang="scss" scoped>
	.c-logo {
		max-width: 250px;
	}

	ul {
		margin: 0;
		padding: 0;
	}

	li {
		list-style: none;
	}

	.c-menu-item {
		position: relative;

		a {
			transition: all 0.3s ease;
			color: white;
		}
		
		a:hover {
			color: $tropical-tangerine;
		}
	}

	.header--dark {
		.c-menu-item {

			a {
				color: $black;
			}

			a:hover {
				color: $grassy-green;
			}
		}
	}

	.c-submenu {
		position: absolute;
		top: 50px;
		left: -80px;
		background: white;
		padding: 25px 20px;
		border: 1px solid #C4C4C4;
		border-radius: 4px;
		min-width: 235px;
		z-index: 2;

		.c-menu-item-seperated {
			border-bottom: 1px solid $grey;
		}

		a {
			color: $black;
		}
	}

	.c-search {
		position: relative;
	}

	.c-search--open {

		::v-deep .c-search-icon {
			position: absolute;
			left: 15px;
			top: 10px;
		}
	}

	.c-search-input {
		width: 186px;
		padding-left: 40px;
		border: 1px solid $light-grey;
		border-radius: 2px;
	}

	.c-notifications {
		background: white;
		position: absolute;
		top: 54px;
		left: -180px;
		width: 360px;
		border-top: 1px solid $light-grey;
	}

	.c-notification-item {
		border-bottom: 1px solid $light-grey;
		padding-bottom: 20px;
		margin-bottom: 20px;

		&:last-child {
			padding-bottom: 0;
			border-bottom: none;
			margin-bottom: 0;
		}

		&__image {
			width: 30px;
			height: 30px;
			border-radius: 50%;
		}
	}

	.c-snackbar {
		padding: 12px 33px 12px 12px;
		background: $lazyblue;
		position: relative;

		&__close {
			position: absolute;
			right: 12px;
			top: 12px;
		}
	}
</style>